module.exports = __webpack_public_path__ + "static/media/star_hover.9f763bf8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/stars/star_hover.svg
// module id = 332
// module chunks = 0